import {useParams} from 'react-router';
import {useStaffSession} from '../ui/StaffSession';
import {ActionRecordWorkspace} from './ActionRecordWorkspace';
import {OperatingWorkQueue} from './OperatingWorkQueue';
import type {WorkQueue} from '../ui/operating-queue';
export type {WorkQueue} from '../ui/operating-queue';
export function WorkDashboard({queue='dashboard',singleRecord=false}:{queue?:WorkQueue;singleRecord?:boolean}){
 const {id}=useParams(),session=useStaffSession(),building=session?.effectiveScope.kind==='building'?session.effectiveScope.id:undefined;
 return singleRecord?<ActionRecordWorkspace key={`${id}:${building??'portfolio'}`} id={id??''} building={building}/>:<OperatingWorkQueue key={`${queue}:${building??'portfolio'}`} queue={queue}/>;
}
